import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import JobPage from "@/pages/JobPage";
import ServicePage from "@/pages/ServicePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/solucoes/:slug" element={<ServicePage />} />
          <Route path="/vagas/enfermeiro-adm-emq" element={<JobPage />} />
          <Route path="/vagas" element={<JobPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
